module.exports = __webpack_public_path__ + "static/media/img_hot_song.fad3e181.png";